import {Injectable} from '@angular/core';
import {CandidatureFormation} from '../candidature';
import { LocalStorageService } from 'ng2-webstorage';

@Injectable()
export class AdmisService {

    private admisCache = 'CADENS_ADMIS_CACHE';
    private indexAdmisCache = 'CADENS_INDEX_ADMIS_CACHE';

    constructor(private localStorageService: LocalStorageService) {
    }

    initCandidatures(cfs: CandidatureFormation[]) {
        this.localStorageService.store(this.admisCache, cfs);
        this.localStorageService.store(this.indexAdmisCache, 0);
    }

    getCurrentCandidature(): CandidatureFormation | null {
        const candidaturesEnTraitement = this.localStorageService.retrieve(this.admisCache);
        const indexCandidatureEnTraitement = this.localStorageService.retrieve(this.indexAdmisCache);
        if(!candidaturesEnTraitement ||  candidaturesEnTraitement.length === 0 ||
            indexCandidatureEnTraitement >= candidaturesEnTraitement.length) {
            return null;
        }
        return candidaturesEnTraitement[indexCandidatureEnTraitement];
    }

    getIndexCandidatureEnTraitement(): number {
        return this.localStorageService.retrieve(this.indexAdmisCache);
    }

    getNbCandidaturesEnTraitement(): number {
        const candidaturesEnTraitement = this.localStorageService.retrieve(this.admisCache);
        return candidaturesEnTraitement ? candidaturesEnTraitement.length : 0;
    }

    previous() {
        const candidaturesEnTraitement = this.localStorageService.retrieve(this.admisCache);
        const index = this.localStorageService.retrieve(this.indexAdmisCache);
        if(index !== undefined && candidaturesEnTraitement && index > 0 && index < candidaturesEnTraitement.length) {
            this.localStorageService.store(this.indexAdmisCache, index - 1);
        }
    }

    next() {
        const candidaturesEnTraitement = this.localStorageService.retrieve(this.admisCache);
        const index = this.localStorageService.retrieve(this.indexAdmisCache);
        if(index !== undefined && candidaturesEnTraitement && index >= 0 && index < candidaturesEnTraitement.length - 1) {
            this.localStorageService.store(this.indexAdmisCache, index + 1);
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/admis/admis.service.ts